import { Star } from "@phosphor-icons/react";
import { useFavorites } from "@/hooks/useFavorites";

export default function FavoriteButton({ slug, className = "", size = 18 }) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(slug);

  return (
    <button
      type="button"
      data-testid={`favorite-toggle-${slug}`}
      aria-label={active ? "Remove from favorites" : "Add to favorites"}
      aria-pressed={active}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleFavorite(slug);
      }}
      className={`grid place-items-center border transition-all duration-150 active:scale-[0.92] ${
        active
          ? "border-accent bg-accent/10 text-accent"
          : "border-border bg-card text-muted-foreground hover:border-accent hover:text-accent"
      } ${className}`}
    >
      <Star size={size} weight={active ? "fill" : "regular"} />
    </button>
  );
}
